// Add this interface declaration at the top of the file to extend the Window interface
declare global {
  interface Window {
    snapSaveState?: () => { snapSaved: boolean };
  }
}

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./i18n/i18n"; // Import i18n configuration
import "./styles/rtl.css"; // Import RTL styles
import "./styles/header-layout.css"; // Header flex / overflow (after rtl overrides)
import "./styles/flipbook.css"; // Import flipbook styles

// Add Tajawal font for Arabic
const tajawalFont = document.createElement("link");
tajawalFont.rel = "stylesheet";
tajawalFont.href =
  "https://fonts.googleapis.com/css2?family=Tajawal:wght@300;400;500;700&display=swap";
document.head.appendChild(tajawalFont);

// Modified for react-snap compatibility
const rootElement = document.getElementById("root")!;

if (rootElement.hasChildNodes()) {
  // If the root element has children, it means react-snap has prerendered the content
  // Use hydrate instead of render
  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
} else {
  // Normal rendering for development and client-side navigation
  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}

// This helps react-snap know when the app is ready to be snapshotted
window.snapSaveState = () => {
  return {
    // You can add any serializable state here that you want to be available
    // when the page is prerendered
    snapSaved: true,
  };
};
